import __var_0__ from './width.js';
import __var_1__ from './height.js';
import __var_2__ from './id.js';
import __var_3__ from './auto_render.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var width = __var_0__;
var height = __var_1__;
var id = __var_2__;
var autoRender = __var_3__;


// MAIN //

var validators = {
	'width': width,
	'height': height,
	'id': id,
	'autoRender': autoRender
};


// EXPORTS //
export default validators;
